import React, { FC } from 'react';
import { useQuery } from '@apollo/client';
import PageContainer from 'components/@layout/PageContainer';
import HomeAccess from './HomeAccess';
import JumpIntoKeyboarding from './JumpIntoKeyboarding';
import StopAndReview from './StopAndReview';
import GET_KEYBOARDING_CLASSROOM_SETTINGS from 'graph/settings/key/get-keyboarding-classroom-settings-query';
import { Classroom } from 'types/schema-generated-types';

interface KeyboardingSettingsProps {
  classroom: Classroom;
  expanded: string | null;
  handleChangeExpanded: (panel: string | null) => () => void;
}

const ClassroomKeyboardingSettings: FC<KeyboardingSettingsProps> = ({
  classroom,
  expanded,
  handleChangeExpanded
}) => {
  const { id: classroomId } = classroom;
  const { data, loading } = useQuery(GET_KEYBOARDING_CLASSROOM_SETTINGS, {
    variables: {
      where: {
        classroomId: Number(classroomId)
      }
    },
    // TODO: Using network-only here to avoid caching because some classroom and student level settings (mostly Home Access)
    // are dependent/derived from one another. In other words, changing the setting at one level will affect the setting at the
    // other level. Figuring out the required cache updates to keep these synced this seemed tricky, so avoiding the cache
    // altogether for now.
    fetchPolicy: 'network-only'
  });

  return (
    <PageContainer loading={loading}>
      <HomeAccess
        classroom={classroom}
        expanded={expanded}
        setting={data?.keyClassroomSettings.homeUse}
        handleChangeExpanded={handleChangeExpanded}
      />
      <JumpIntoKeyboarding
        classroom={classroom}
        expanded={expanded}
        setting={data?.keyClassroomSettings.skipJumpIn}
        handleChangeExpanded={handleChangeExpanded}
      />
      <StopAndReview
        classroom={classroom}
        expanded={expanded}
        setting={data?.keyClassroomSettings.stopAndReview}
        handleChangeExpanded={handleChangeExpanded}
      />
    </PageContainer>
  );
};

export default ClassroomKeyboardingSettings;
